module.exports = __webpack_public_path__ + "img/banner_hero_mobile.d39f56c2.jpg";